export default function disableElement(profile: string[]) {
  if(!profile) {
    return false
  }
  return profile.includes('ALL_READONLY')
}